if (typeof DisplayForm !== 'function') {
class DisplayForm extends HTMLElement {
    connectedCallback() {
        const button = this.querySelector('.open-appointment');
        
        button.addEventListener('click', e => {
            const ridicareElement = document.querySelector('.ridicare-personala-container .contact__form');

            if (ridicareElement) {
                ridicareElement.classList.toggle('active');
            }
        });
    }
}

    if (!customElements.get('button-form')) {
        customElements.define('button-form', DisplayForm);
    }
}